var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: !0 });
import { s as size, _ as __spreadValues } from "./chunk-JJ6VZ5V7-350b4003.mjs";
import * as React from "react";
import { s as styled, c as color } from "./lib-42970741.mjs";
import "@aircall/icons";
import "@aircall/tractor-v2";
import "styled-components";
import "react-router-dom";
import "@aircall/hooks";
import "react-final-form";
import "react-dom";
import "react-router";
import "final-form";
var SvgComponent = /* @__PURE__ */ __name((props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    viewBox: "0 0 32 32"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#E94B35",
      fillRule: "evenodd",
      d: "M.003 16h31.994v.016c.033 2.493-.2 5.317-.864 8.108 0 0-1.028 4.918-5.476 6.646-2.09.83-5.907 1.196-9.657 1.23-3.75-.034-7.567-.432-9.658-1.23C1.895 29.042.866 24.124.866 24.124.171 21.34-.029 18.521.003 16Z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#227FBB",
      fillRule: "evenodd",
      d: "M31.997 16H.003v-.017c-.033-2.492.2-5.316.863-8.108 0 0 1.03-4.918 5.476-6.646C8.433.432 12.25.033 16 0c3.75.033 7.567.432 9.69 1.263 4.448 1.728 5.477 6.646 5.477 6.646.662 2.752.862 5.57.83 8.091Z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#F2C500",
      fillRule: "evenodd",
      d: "M6.667 6.09V5a.333.333 0 0 1 .667 0v1.09a.666.666 0 1 1-.667 0ZM7 8c-.507 0-.879.284-.901 1.007-.124-.26-.648-1.074-1.136-.965-.29.065-.547.544-.504 1.093-.24-.822-.945-.957-1.459-.47.456.446.66 1.763 1.044 2.335h5.911c.384-.572.588-1.89 1.045-2.336-.514-.486-1.219-.351-1.46.471.044-.549-.214-1.028-.504-1.093-.489-.109-1.011.706-1.135.965C7.88 8.284 7.506 8 7 8Z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#F2C500",
      d: "M9.569 6.823c.417.358.386 1-.192 2.012l-.165.29.579.33.165-.29c.717-1.255.765-2.232.047-2.848-.702-.602-1.63-.502-2.715.224a.333.333 0 0 0-.145.318l.281 2.267.662-.083-.256-2.058c.774-.475 1.335-.509 1.739-.162Zm-3.401.135c-.774-.474-1.335-.508-1.739-.161-.417.358-.386 1 .192 2.012l.165.289-.579.33-.165-.289c-.717-1.255-.765-2.233-.047-2.848.702-.602 1.63-.503 2.715.223.105.07.16.194.145.319l-.281 2.266-.662-.082.256-2.058Z"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#000",
      fillRule: "evenodd",
      d: "M10 11.087c0 .276-1.344.58-3 .58s-3-.304-3-.58c0-.276 1.344-.42 3-.42s3 .144 3 .42Z",
      clipRule: "evenodd"
    }
  )
), "SvgComponent"), SvgFlagLie = styled(SvgComponent)`
  ${size}
  ${color}
`, FlagLie_default = SvgFlagLie;
export {
  FlagLie_default as default
};
